export default __webpack_public_path__ + "static/media/4.blur.f5912514.jpg";